module.exports = __webpack_public_path__ + "static/media/04-video.92e7cb4a.png";